import React, { Fragment, useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { inviteRuleAddress } from '@service';
import { Form, Row, Col, Select, InputNumber } from 'antd';
import {
  selConfig,
  options,
  disOptions,
  disConfig,
  provinceConfig,
  cityConfig,
  areaConfig,
  invProvinceConfig,
  invCityConfig,
  invAreaConfig,
  initialVal,
  numConfig,
} from './config';
import './index.less';

const { Item } = Form;

const DistrictSelect = (props, ref) => {
  const { initialValues: initialValuesFromProps, type, handleRulesChange = () => {} } = props;

  const [provinces, setProvinces] = useState([]);
  const [isPart, setIsPart] = useState('1');
  const [ifShowForm, setIfShowForm] = useState(false);
  const [isPartShow, setIsPartShow] = useState('1');
  const [city, setCity] = useState([]);
  const [area, setArea] = useState([]);
  const [invProvinces, setInvProvinces] = useState([]);
  const [invCity, setInvCity] = useState([]);
  const [invArea, setInvArea] = useState([]);
  const [form] = Form.useForm();

  const getDistrcit = async areaId => {
    const { flag, data } = await inviteRuleAddress({ areaId });

    return flag === 200 ? data : [];
  };

  useEffect(() => {
    const getIntial = async () => {
      const {
        id,
        invite_province,
        invite_city,
        invitee_province,
        invitee_city,
        type,
        reject_all,
      } = initialValuesFromProps;

      if (id) {
        invite_province &&
          (await getDistrcit(invite_province).then(res => {
            setCity(res);
          }));
        invite_city &&
          (await getDistrcit(invite_city).then(res => {
            setArea(res);
          }));
        invitee_province &&
          (await getDistrcit(invitee_province).then(res => {
            setInvCity(res);
          }));
        invitee_city &&
          (await getDistrcit(invitee_city).then(res => {
            setInvArea(res);
          }));

        setIfShowForm(true);
        setIsPart(type);
        setIsPartShow(reject_all);
        form.setFieldsValue(initialValuesFromProps);
      }
    };

    getIntial();
  }, [initialValuesFromProps]);

  useEffect(() => {
    getDistrcit(0).then(res => {
      setProvinces(res);
      setInvProvinces(res);
    });
  }, []);

  const onValuesChange = changedValues => {
    const key = Object.keys(changedValues || {})[0];
    const val = changedValues[key];

    switch (key) {
      case 'invite_province':
        getDistrcit(val).then(res => {
          setCity(res);
          form.setFieldsValue({
            invite_city: null,
            invite_area: null,
          });
        });
        break;
      case 'invite_city':
        getDistrcit(val).then(res => {
          setArea(res);
          form.setFieldsValue({
            invite_area: null,
          });
        });
        break;
      case 'invitee_province':
        getDistrcit(val).then(res => {
          setInvCity(res);
          form.setFieldsValue({
            invitee_city: null,
            invitee_area: null,
          });
        });
        break;
      case 'invitee_city':
        getDistrcit(val).then(res => {
          setInvArea(res);
          form.setFieldsValue({
            invitee_area: null,
          });
        });
        break;
      case 'type':
        setIfShowForm(true);
        setIsPart(val);
        handleRulesChange();
        break;
      case 'reject_all':
        setIsPartShow(val);
        break;
    }
  };

  const selectBegin = () => {};

  const onConfirm = async () => {
    try {
      const res = await form.validateFields();

      return res;
    } catch (errorInfo) {
      return errorInfo;
    }
  };

  useImperativeHandle(ref, () => ({
    onConfirm,
    selectBegin,
  }));

  return (
    <Form form={form} initialValues={initialVal} onValuesChange={onValuesChange}>
      {type !== 'all' ? (
        <Fragment>
          <Row>
            <Item {...selConfig}>
              <Select options={options} />
            </Item>
          </Row>

          {ifShowForm && (
            <Fragment>
              {isPart === '0' && (
                <Row>
                  <Item {...disConfig}>
                    <Select options={disOptions} />
                  </Item>
                </Row>
              )}

              <Row align="middle" className="gray-background">
                {(isPart === '1' || (isPart === '0' && isPartShow === '0')) && (
                  <Fragment>
                    <Col span={10}>
                      <Item label="邀请人所在地区">
                        <Item {...provinceConfig}>
                          <Select options={provinces} placeholder="请选择省" />
                        </Item>
                        <Item {...cityConfig}>
                          <Select options={city} placeholder="请选择市" />
                        </Item>
                        <Item {...areaConfig}>
                          <Select options={area} placeholder="请选择省" />
                        </Item>
                      </Item>
                    </Col>
                    <Col span={4} push={1}>
                      的批发商邀请
                    </Col>
                  </Fragment>
                )}
                <Col span={10}>
                  <Item label="被邀请所在地区">
                    <Item {...invProvinceConfig}>
                      <Select options={invProvinces} placeholder="请选择省" />
                    </Item>
                    <Item {...invCityConfig}>
                      <Select options={invCity} placeholder="请选择市" />
                    </Item>
                    <Item {...invAreaConfig}>
                      <Select options={invArea} placeholder="请选择省" />
                    </Item>
                  </Item>
                </Col>
              </Row>

              {isPart === '1' && (
                <Row>
                  <Item {...numConfig}>
                    <InputNumber min={0} />
                  </Item>
                </Row>
              )}
            </Fragment>
          )}
        </Fragment>
      ) : (
        <Item label="允许">
          <Row justify="space-around" align="middle">
            <Col span={7}>
              <Item {...invProvinceConfig}>
                <Select options={invProvinces} placeholder="请选择省" />
              </Item>
            </Col>
            <Col span={7}>
              <Item {...invCityConfig}>
                <Select options={invCity} placeholder="请选择市" />
              </Item>
            </Col>
            <Col span={7}>
              <Item {...invAreaConfig}>
                <Select options={invArea} placeholder="请选择省" />
              </Item>
            </Col>
          </Row>
        </Item>
      )}
    </Form>
  );
};

export default forwardRef(DistrictSelect);
